import { CategoryInput } from 'common/form/input/_categoryInput'
import { useHistoryStudentFilterForm } from '../../../../hooks/useHistoryStudentFilterForm'

export const OrderSearch = () => {
  const {orderId} = useHistoryStudentFilterForm()
  return (
  <CategoryInput
    className={'order-filter-form__input-wide'}
    categoryList={[]}
    categoryValue={{name: 'Mã đơn hàng', value: ''}}
    categoryWidth={104}
    placeholder='Nhập mã đơn hàng'
    value={orderId?.value || ''}
    onChange={orderId.onChange}
    style={{ position: 'relative'}}
  />
  )
}
